import { mapActions } from "vuex";

export default {
    created() {

    },
    methods: {
        ...mapActions({
            saveAll: 'crudStore/saveAll',
            assignDataForm: 'crudStore/assignDataForm',
        }),
        async actualizarFtn() {
            try {

            } catch {

            }
        },
        async saveForm(event) {
            try {
                let savePost = false
                if (event.ftn !== undefined) {
                    switch (event.ftn) {
                        case 'anularRegistroFtn':
                            let info_egresos = this.dataForm[this.namePath].info_egresos
                            info_egresos.deleted_at = this.fecha().fecha.delete
                            await this.assignDataForm({ state: 'info_egresos', data: info_egresos })

                            const await5 = this.updateDataPost({ state: 'data', data: [] })
                            const await0 = this.updateDataPost({ state: 'tablaPost', data: ['info_egresos'] })
                            const await1 = this.updateDataPost({ state: 'tablaDelete', data: [] })
                            const await2 = this.updateDataPost({ state: 'route', data: 'save_all' })
                            const await3 = this.updateDataPost({ state: 'tablaAuditar', data: true })
                            const await4 = this.updateDataPost({ state: 'notaDelete', data: null })

                            await Promise.all([await0, await1, await2, await3, await4])

                            break;
                        case 'registroFtn':
                            await this.updateDataPost({
                                data: {
                                    data: [],
                                    route: 'save_all',
                                    tablaAuditar: true,
                                    notaDelete: null,
                                    tablaPost: ['info_egresos'],
                                    tablaDelete: []
                                }
                            })
                            break;
                    }
                }

                let dataSave = await this.save(event.save, savePost)

                if (event.ftn === 'registroFtn') {
                    window.open(this.url + '/api/pdf/egresos?id=' + dataSave.ids.info_egresos.toString() + '&token=' + this.token, '_blank')
                }

                const await30 = this.getDataGet({ route: 'get_egresosinformes', data: { inicial: this.filter.inicial, final: this.filter.final, others: [] } })
                    // frotend await this.searchIdb({tabla:'servicios_nuevos',campo:'iniciolabores',value:'',principal:'info_afiliacion'})
                const await31 = this.resetDataIndex()
                const await32 = this.resetGlobal({ state: 'openModal' })
                const await33 = this.resetDataForm()
                const await34 = this.resetGlobal({ state: 'saveConfig/capa' })
                await Promise.all([await30, await31, await32, await33, await34])
            } catch (e) {
                console.log(e)

            }
        }
    },
}